/**
 * The Financial Structures route table (FSD 1.2.7 — Ledgers, Ledger Sets,
 * Accounting Methods, Accounting Calendars).
 *
 * `web/src/router/index.ts` and `web/src/nav/**` are shared files this packet does
 * NOT own — the orchestrator spreads `ENTERPRISE_LEDGER_ROUTES` into the router and
 * adds the nav entries.
 *
 * Every route is gated on its record's **read** permission; every write (add a
 * reporting currency, create a ledger set or add a member, create an accounting
 * method, define a calendar) is checked on the action itself, so an Auditor holding
 * only the read permissions can open each screen and change nothing.
 */

import type { RouteRecordRaw } from 'vue-router'

import { LEDGER_PERMISSIONS } from '@/modules/enterprise/ledgers/permissions'

export const LEDGERS_PATH = '/enterprise/ledgers'
export const LEDGER_SETS_PATH = '/enterprise/ledger-sets'
export const ACCOUNTING_METHODS_PATH = '/enterprise/accounting-methods'
export const ACCOUNTING_CALENDARS_PATH = '/enterprise/accounting-calendars'

export function ledgersRoute(): string {
  return LEDGERS_PATH
}

export function ledgerSetsRoute(): string {
  return LEDGER_SETS_PATH
}

export function accountingMethodsRoute(): string {
  return ACCOUNTING_METHODS_PATH
}

export function accountingCalendarsRoute(): string {
  return ACCOUNTING_CALENDARS_PATH
}

export const ENTERPRISE_LEDGER_ROUTES: RouteRecordRaw[] = [
  {
    path: LEDGERS_PATH,
    name: 'enterprise-ledgers',
    component: () => import('@/modules/enterprise/ledgers/LedgersView.vue'),
    meta: {
      titleKey: 'enterprise.ledgers.routeTitles.ledgers',
      permission: LEDGER_PERMISSIONS.ledgerRead,
    },
  },
  {
    path: LEDGER_SETS_PATH,
    name: 'enterprise-ledger-sets',
    component: () => import('@/modules/enterprise/ledgers/LedgerSetsView.vue'),
    meta: {
      titleKey: 'enterprise.ledgers.routeTitles.ledgerSets',
      permission: LEDGER_PERMISSIONS.ledgerSetRead,
    },
  },
  {
    path: ACCOUNTING_METHODS_PATH,
    name: 'enterprise-accounting-methods',
    component: () => import('@/modules/enterprise/ledgers/AccountingMethodsView.vue'),
    meta: {
      titleKey: 'enterprise.ledgers.routeTitles.accountingMethods',
      permission: LEDGER_PERMISSIONS.accountingMethodRead,
    },
  },
  {
    path: ACCOUNTING_CALENDARS_PATH,
    name: 'enterprise-accounting-calendars',
    component: () => import('@/modules/enterprise/ledgers/AccountingCalendarsView.vue'),
    meta: {
      titleKey: 'enterprise.ledgers.routeTitles.accountingCalendars',
      permission: LEDGER_PERMISSIONS.fiscalRead,
    },
  },
]
